module.exports = __webpack_public_path__ + "img/circle.d381d49c.png";